// extracted by mini-css-extract-plugin
export var accesDirectContainer = "acces-direct-module--acces-direct-container--1719c";
export var accesDirectDescription = "acces-direct-module--acces-direct-description--25ad7";
export var accesDirectItem = "acces-direct-module--acces-direct-item--c5af6";
export var accesDirectItemDescription = "acces-direct-module--acces-direct-item-description--30dd3";
export var accesDirectTitle = "acces-direct-module--acces-direct-title--155ca";
export var editButton = "acces-direct-module--edit-button--18b9d";
export var editButtonTitle = "acces-direct-module--edit-button-title--07aaa";